module.exports = __webpack_public_path__ + "static/media/bmw-logo.1a685efc.png";